"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parsedBreadcrumbs = exports.breadcrumbs = void 0;
const breadcrumbs = exports.breadcrumbs = {
    links: [
        {
            title: 'Home',
            id: '/',
            type: 'Custom',
            attributes: []
        },
        {
            title: 'Our product philosophy',
            id: '/product-philosophy',
            type: 'Custom',
            attributes: []
        },
        {
            title: 'Ingredient library',
            id: '/product-philosophy/ingredient-library',
            type: 'Custom',
            attributes: []
        },
        {
            title: 'Coconut',
            id: '/product-philosophy/ingredient-library/coconut',
            type: 'Custom',
            attributes: []
        }
    ]
};
const parsedBreadcrumbs = exports.parsedBreadcrumbs = [
    {
        ItemLabel: 'Home',
        Url: '/'
    },
    {
        ItemLabel: 'Our product philosophy',
        Url: '/product-philosophy'
    },
    {
        ItemLabel: 'Ingredient library',
        Url: '/product-philosophy/ingredient-library'
    },
    {
        ItemLabel: 'Coconut',
        Url: '/product-philosophy/ingredient-library/coconut'
    }
];
